export default "__VITE_ASSET__DqvtHRFB__"